export const blockIconsHardwareKeyboardArrowDownNew = (
	<span className='material-symbols-outlined'>keyboard_arrow_down</span>
);
